import React from 'react';
import ReactDOM from 'react-dom';
import { Field,formValueSelector,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
import Helpers from '../../../helpers/General.js';

const validate = values => {
    const errors = {}

    if (!values.COMPANY_NAME) {
        errors.COMPANY_NAME = 'Required'
    }

    if (!values.COMPANY_ADDRESS_1) {
        errors.COMPANY_ADDRESS_1 = 'Required'
    }

    if (!values.COMPANY_POSTCODE) {
        errors.COMPANY_POSTCODE = 'Required'
    }

    if (!values.COMPANY_CITY) {
        errors.COMPANY_CITY = 'Required'
    }

    if (!values.EMAIL_REASON) {
        errors.EMAIL_REASON = 'Required'
    }

    if (!values.COMPANY_COUNTRY) {
        errors.COMPANY_COUNTRY = 'Required'
    }

    if (!values.EMAIL_UNSUBSCRIBE) {
        errors.EMAIL_UNSUBSCRIBE = 'Required'
    }


    return errors;
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)



class CompanyDetails extends React.Component {


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">


                    <div className="row p-15">
                        <div className="row">
                            <div className="col-sm-12">
                                <Field component={renderField} type="text" placeholder="Acme Inc" name="COMPANY_NAME"  className="form-control" title="Company name" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <Field component={renderField} type="text" placeholder="Kirkeveien 1" name="COMPANY_ADDRESS_1"  className="form-control" title="Address line 1" />
                            </div>

                            <div className="col-sm-6">
                                <Field component={renderField} type="text" name="COMPANY_ADDRESS_2"  className="form-control" title="Address line 2" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-4">
                                <Field component={renderField} type="text" placeholder="Oslo" name="COMPANY_CITY"  className="form-control" title="City" />
                            </div>

                            <div className="col-sm-4">
                                <Field component={renderField} type="text" placeholder="0034" name="COMPANY_POSTCODE"  className="form-control" title="Postcode" />
                            </div>

                            <div className="col-sm-4">
                                <Field component={renderField} type="text" placeholder="Norway" name="COMPANY_COUNTRY"  className="form-control" title="Country" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <Field component={renderField} type="text" placeholder="" name="EMAIL_REASON"  className="form-control" title="Reason why customers are receiving e-mails from you" />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <Field component={renderField} type="text" placeholder="" name="EMAIL_UNSUBSCRIBE"  className="form-control" title="Unsubscribe text" />
                            </div>
                        </div>

                    </div>

                    <div className="row m-t-20">
                        <div className="col-sm-12">
                            {
                                this.props.isWaiting
                                    ?
                                    <LoadingSmall />
                                    :
                                    <button type="submit" className="btn btn-dark btn-block">Update</button>
                            }
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}
const selector = formValueSelector('CompanyDetails');

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
CompanyDetails = reduxForm({
    form: 'CompanyDetails',
    validate,
})(CompanyDetails);

CompanyDetails = connect(
    state => ({
        initialValues: {
            COMPANY_NAME: state.general.settings.COMPANY_NAME,
            COMPANY_ADDRESS_1: state.general.settings.COMPANY_ADDRESS_1,
            COMPANY_ADDRESS_2: state.general.settings.COMPANY_ADDRESS_2,
            COMPANY_COUNTRY: state.general.settings.COMPANY_COUNTRY,
            COMPANY_CITY: state.general.settings.COMPANY_CITY,
            COMPANY_POSTCODE: state.general.settings.COMPANY_POSTCODE,
            EMAIL_UNSUBSCRIBE: state.general.settings.EMAIL_UNSUBSCRIBE,
            EMAIL_REASON:state.general.settings.EMAIL_REASON,
        }
    })
)(CompanyDetails)

export default CompanyDetails;



// WEBPACK FOOTER //
// ./containers/settings/form/CampanyDetails.js